import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import Image from "../../../image/image";
import { FormattedMessage } from "react-intl";
import TypewriterAnimation from "@default/general-components/typewriter-animation";
import Hyphenate from "@default/general-components/custom-hyphenation";

const MotionLink = motion.create(Link);

const CardTeaser = ({ content, index = 0 }) => {
  const [searchParams] = useSearchParams();

  const paramValue = searchParams.get("card-overlay") ?? "";
  const isActive =
    paramValue === String(content.id) ||
    paramValue.startsWith(`${content.id}-`);

  const toParams = new URLSearchParams(searchParams);
  if (isActive) {
    toParams.delete("card-overlay");
  } else {
    toParams.set(
      "card-overlay",
      `${content.id}-${
        content.fieldHeading?.toLowerCase().replace(/[^a-z0-9]+/g, "-") ?? ""
      }`
    );
  }

  return (
    <MotionLink
      className="card-teaser action-element"
      to={{ search: toParams.toString() }}
      style={
        content.fieldMainColors
          ? { "--card-color": `var(--c-${content.fieldMainColors})` }
          : undefined
      }
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut", delay: index * 0.08 }}
    >
      {content.fieldImage?.fieldMediaImage && (
        <Image
          data={content.fieldImage.fieldMediaImage}
          credit={content.fieldImage.fieldCredits}
        />
      )}
      <div className="text-wrapper">
        {content.fieldHeading && (
          <h3 className="heading headline-m">
            <Hyphenate>{content.fieldHeading}</Hyphenate>
          </h3>
        )}
        <span className="read-more typewriter-anchor">
          <TypewriterAnimation>
            <FormattedMessage id="read_more" />
          </TypewriterAnimation>
        </span>
      </div>
    </MotionLink>
  );
};

export default CardTeaser;
